module.exports = window.wp.reduxRoutine;